import gatherIceCandidates from '../locality/gatherIceCandidates';
import logger from '../log';
import { addDuration } from '../common/utils/duration';
import { BasePromiseData, EMPTY_ICE } from './interfaces';
import { IceCandidateStructure } from '../locality/interfaces';
import supportsWebRTC from '../common/utils/supportsWebRTC';

const log = logger.getLogger(__filename);

type IcsPromise = Promise<IceCandidateStructure>;

const getNetworkData = (obj: BasePromiseData): IcsPromise => {
  const { base, vals } = obj;
  const { timeout } = base;
  const callback = (value: IceCandidateStructure) => {
    log.debug('ICE done. Received: ', value);
    addDuration({ vals: vals, key: 'ICE' });
  };

  if (supportsWebRTC()) {
    // gatherIceCandidate Manages timeouts internally.
    return gatherIceCandidates({ timeout }).then(
      v => {
        callback(v);
        return v;
      },
      e => {
        callback({} as IceCandidateStructure);
        log.info('Unable to gather network data', e as Record<string, unknown>);
        return EMPTY_ICE;
      }
    );
  } else {
    callback({} as IceCandidateStructure);
    log.info('Webrtc not supported');
    return Promise.resolve(EMPTY_ICE);
  }
};

export default getNetworkData;
